import React from "react";
import { Link } from "react-router-dom";

import search from "../../public/search.svg";
import search_dark from "../../public/search_dark.svg";

import wheretogo_1 from "../../public/wheretogo-sumava/wheretogo_1.png";
import wheretogo_2 from "../../public/wheretogo-sumava/wheretogo_2.png";
import wheretogo_3 from "../../public/wheretogo-sumava/wheretogo_3.png";
import wheretogo_4 from "../../public/wheretogo-sumava/wheretogo_4.png";
import wheretogo_5 from "../../public/wheretogo-sumava/wheretogo_5.png";

import { useContext } from "react";
import { DarkModeContext } from "../../components/DarkModeProvider"

import { useUserContext } from "../../context/userContext";


const KamSeVydatNaSumave = () => {

  const { user } = useUserContext();

  const { darkMode } = useContext(DarkModeContext);

  return (
    <>
      <section className={darkMode ? "where__to--go dark" : "where__to--go light"}>
        <div className="container">
          <div className="where__to--go--heading">
          <img src={darkMode ? search_dark : search} alt="" />
            <h1 className={darkMode ? "dark-text" : "light-text"}>Kam se vydat na Šumavě</h1>
          </div>
        </div>
      </section>

      <section className={darkMode ? "where__to--go--main dark" : "where__to--go--main light"}>
        <div className="container">
          <div className="where__to--go--container">
            <div className="where__to--go--image">
              <img src={wheretogo_1} alt="" />
            </div>
            <div className="where__to--go--content">
              <h3 className={darkMode ? "dark-text" : "light-text"}>Plechý</h3>
              <p className={darkMode ? "dark-second-text" : "light-second-text"}>
                Plechý je 1378 m. n. m. vysoká hora ležící v pohoří Šumava. Je pátým
                nejvyšším vrcholem na Šumavě, nejvyšším vrcholem české i
                rakouské části Šumavy a zároveň i nejvyšším vrcholem Jihočeského
                kraje. Zároveň je devátou nejizolovanější českou horou.
              </p>
              <Link className={darkMode ? 'dark-button-text' : 'light-button-text'} to="/sumava/kamsevydat/plechy">
                <span>Více</span>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className={darkMode ? "where__to--go--main dark" : "where__to--go--main light"}>
        <div className="container">
          <div className="where__to--go--container">
            <div className="where__to--go--image">
              <img src={wheretogo_2} alt="" />
            </div>
            <div className="where__to--go--content">
              <h3 className={darkMode ? "dark-text" : "light-text"}>Boubín</h3>
              <p className={darkMode ? "dark-second-text" : "light-second-text"}>
                Boubín je hora v Boubínské hornatině, pátý nejvyšší vrchol české
                části Šumavy a třetí nejvyšší v Jihočeském kraji. Je 16.
                nejvyšší horou ležící uvnitř území ČR a nejvyšší takovou horou
                na Šumavě a v Jihočeském kraji.
              </p>
              <Link className={darkMode ? 'dark-button-text' : 'light-button-text'} to="/sumava/kamsevydat/boubin">
                <span>Více</span>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className={darkMode ? "where__to--go--main dark" : "where__to--go--main light"}>
        <div className="container">
          <div className="where__to--go--container">
            <div className="where__to--go--image">
              <img src={wheretogo_3} alt="" />
            </div>
            <div className="where__to--go--content">
              <h3 className={darkMode ? "dark-text" : "light-text"}>Poledník</h3>
              <p className={darkMode ? "dark-second-text" : "light-second-text"}>
                Poledník je hora ležící na Kvildských pláních v pohoří Šumava.
                Poledník je s nadmořskou výškou 1315 metrů patnáctý nejvyšší
                vrchol české části Šumavy. Nachází se 4,5 km jižně od Prášil.
              </p>
              <Link className={darkMode ? 'dark-button-text' : 'light-button-text'} to="/sumava/kamsevydat/polednik">
                <span>Více</span>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className={darkMode ? "where__to--go--main dark" : "where__to--go--main light"}>
        <div className="container">

          {user ?
            <div className="where__to--go--container">
              <div className="where__to--go--image">
                <img src={wheretogo_4} alt="" />
              </div>
              <div className="where__to--go--content">
                <h3 className={darkMode ? "dark-text" : "light-text"}>Vítkův hrádek</h3>
                <p className={darkMode ? "dark-second-text" : "light-second-text"}>
                  Vítkův hrádek je zřícenina gotického hradu na vrcholu
                  stejnojmenné hory na pravém břehu Lipenské přehrady v okrese
                  Český Krumlov. Zřícenina stojí nad osadou Svatý Tomáš, asi pět
                  kilometrů od Přední Výtoně. Je to nejvýše položený hrad v Česku.
                  Od roku 1963 je chráněn jako kulturní památka.
                </p>
                <Link className={darkMode ? 'dark-button-text' : 'light-button-text'} to="/sumava/kamsevydat/vitkuvhradek">
                  <span>Více</span>
                </Link>
              </div>
            </div>
          :

            <div className="where__to--go--container">
              <div className="where__to--go--image where__to--go--container--locked">
                <img src={wheretogo_4} alt="" />
              </div>
              <div className="where__to--go--content where__to--go--container--locked">
                <h3  className={darkMode ? "dark-text " : "light-text"}>Pro registrované</h3>
                <p className={darkMode ? "dark-second-text" : "light-second-text"}>
                    Zaregistrujte se už dnes a získejte přístup k prémiovým místům
                </p>
                <Link className={darkMode ? 'dark-button-text' : 'light-button-text'} to="/profile">
                  <span>Více</span>
                </Link>
              </div>
            </div> 
          }

        </div>
      </section>

      <section className={darkMode ? "where__to--go--main dark" : "where__to--go--main light"}>
        <div className="container">

          {user ?
          <div className="where__to--go--container">
            <div className="where__to--go--image">
              <img src={wheretogo_5} alt="" />
            </div>
            <div className="where__to--go--content">
              <h3 className={darkMode ? "dark-text" : "light-text"}>Chalupská slať</h3>
              <p className={darkMode ? "dark-second-text" : "light-second-text"}>
                Chalupská slať je rašeliniště přechodného typu mezi údolním a
                horským vrchovištěm. Slať je zpřístupněna naučnou stezkou, která
                vede po 260 metrů dlouhé poválkové cestě. Na okraji se v
                minulosti těžila rašelina. Přes slať vedla tzv. „Kiliánova
                trasa“.
              </p>
              <Link className={darkMode ? 'dark-button-text' : 'light-button-text'} to="/sumava/kamsevydat/chalupskaslat">
                <span>Více</span>
              </Link>
            </div>
          </div>
          :
          <div className="where__to--go--container">
            <div className="where__to--go--image where__to--go--container--locked">
              <img src={wheretogo_5} alt="" />
            </div>
            <div className="where__to--go--content where__to--go--container--locked">
              <h3  className={darkMode ? "dark-text " : "light-text"}>Pro registrované</h3>
              <p className={darkMode ? "dark-second-text" : "light-second-text"}>
                  Zaregistrujte se už dnes a získejte přístup k prémiovým místům
              </p>
              <Link className={darkMode ? 'dark-button-text' : 'light-button-text'} to="/profile">
                <span>Více</span>
              </Link>
            </div>
          </div> 
          }
        </div>
      </section>
    </>
  );
};

export default KamSeVydatNaSumave;
